ListControlDirective.$inject = ['$location'];
function ListControlDirective($location) {
    return {
        link: function (scope, elem, attrs) {
            var DEFAULT_SIZE = 20;
            var _KEY = attrs.key;
            scope.savekey = _KEY;
            scope.$watch(function () {
                return $location.search();
            }, function (params, old) {
                // console.log('params changed');
                if (params === old || params.size !== old.size || params.page !== old.page || params.q !== old.q) {
                    fetch(params);
                }
            }, true);
            function fetch(params) {
                // var page = params.page || Number(localStorage.getItem(_KEY + ':pagenum')) || 1;
                var page = params.page || 1;
                var pagesize = Number(params.size) || Number(localStorage.getItem(_KEY + ':pagesize')) || DEFAULT_SIZE;
                var q = params.q || '';
                scope.$emit('refreshList', [{
                        page: page,
                        size: pagesize,
                        q: q
                    }]);
            }
        }
    };
}
angular.module('rinca.core.directives.list-control', [])
    .directive('rcListControl', ListControlDirective);



//////////////////
// WEBPACK FOOTER
// ./scripts/core/directives/ListControlDirective.js
// module id = 302
// module chunks = 0